import React, { useState } from 'react';
import { Lock, Eye, EyeOff, CheckCircle2 } from 'lucide-react';

const StepNewPassword = ({ onSubmit, loading, passwordError }) => {
    const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPass, setShowPass] = useState(false);
  const [showConfirmPass, setShowConfirmPass] = useState(false);

  return (
    <div className="fp-step">
      <div className="fp-step__icon"><Lock size={26} /></div>
      <h3 className="fp-step__title">Create new password</h3>
      <p className="fp-step__sub">Your new password must be different from previous passwords.</p>

      <div className="fp-field">
        <label>New Password</label>
        <div className="fp-input-wrap">
          <input
            type={showPass ? 'text' : 'password'}
            placeholder="••••••••"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="fp-input"
          />
          <button type="button" className="fp-eye-btn" onClick={() => setShowPass(!showPass)}>
            {showPass ? <EyeOff size={17} /> : <Eye size={17} />}
          </button>
        </div>
      </div>

    <div className="fp-field">
  <label>Confirm Password</label>

  <div className="fp-input-wrap">
    <input
      type={showConfirmPass ? 'text' : 'password'}
      placeholder="••••••••"
      value={confirmPassword}
      onChange={(e) => setConfirmPassword(e.target.value)}
      className="fp-input"
    />

    <button
      type="button"
      className="fp-eye-btn"
      onClick={() => setShowConfirmPass(!showConfirmPass)}
    >
      {showConfirmPass ? <EyeOff size={17} /> : <Eye size={17} />}
    </button>
  </div>

  {passwordError && (
    <p className="fp-error">{passwordError}</p>
  )}
</div>

      <button
        className="fp-btn-primary"
        onClick={() => onSubmit(password, confirmPassword)}
        disabled={loading}
      >
        {loading ? <span className="fp-spinner" /> : <>Reset Password <CheckCircle2 size={16} /></>}
      </button>
    </div>
  );
};

export default StepNewPassword;